<script>
export default {
    name: "VBtnMenu",
    functional: true,
}
</script>

<template functional>
    <v-btn
        v-bind="data.attrs"
        v-on="data.on"
        :class="['v-btn-with-menu pr-0', data.class, data.staticClass]"
    >
        <slot></slot>
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    @click.stop.prevent
                >
                    <v-icon
                        color="white"
                        :class="{'menu-active':attrs['aria-expanded'] === 'true'}">mdi-menu-down
                    </v-icon>
                </v-btn>
                <v-divider vertical></v-divider>
            </template>
            <v-list>
                <slot name="menu"></slot>
            </v-list>
        </v-menu>
    </v-btn>
</template>

<style scoped lang="scss">
.v-btn-with-menu::v-deep {
    padding-right: 0;

    &.v-btn--disabled {
        .v-btn__content {
            .v-divider--vertical {
                background-color: #f0f0f0;
                border-color: #f0f0f0;
            }
        }
    }

    .v-btn__content {
        .v-divider--vertical {
            background-color: silver;
            align-self: normal;
            margin: 0 0 0 16px;
        }

        .mdi-menu-down {
            transform: rotate(0deg);

            &.menu-active {
                transform: rotate(180deg);
            }
        }
    }
}
</style>
